import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card card-with-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "col-lg-4" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "position-relative" }
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { class: "col-lg-4" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "position-relative" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "position-relative" }
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["src"]

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import PageLoading from "@/components/Common/PageLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import { ItemDataResponse } from "@/types/interface/item";
import { useUnitStore } from "@/stores/master/unit";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { mapOptionMultiselect, urlToObject } from "@/utils/helper";
import ImageUploader from "@/components/Common/ImageUploader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateItem',
  setup(__props) {

const idItem = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const itemStore = useItemStore();
const detailItem = ref<ItemDataResponse>();
const unitStore = useUnitStore();
const groupCategoryStore = useCategoryGroupStore();
const listGroupCategory = ref<any>();
const listUnit = ref<any>();
const previewUrl = ref("");

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    // msg_code: zod.string().nonempty({ message: "MSG Code is required" }),
    impa_code: zod.string().nonempty({ message: "Impa Code is required" }),
    group_category_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    unit_type_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    size: zod.string().nonempty({ message: "Size is required" }),
    remarks: zod.string().nonempty({ message: "Remarks is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: msg_code } = useField<string>("msg_code");
const { value: impa_code } = useField<string>("impa_code");
const { value: group_category_id } = useField<string>("group_category_id");
const { value: unit_type_id } = useField<string>("unit_type_id");
const { value: size } = useField<string>("size");
const { value: image_file } = useField<any>("image_file");
const { value: remarks } = useField<string>("remarks");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const formData = new FormData();
  formData.append("name", name.value);
  formData.append("msg_code", msg_code.value);
  formData.append("impa_code", impa_code.value);
  formData.append("group_category_id", group_category_id.value?.value);
  formData.append("unit_type_id", unit_type_id.value?.value);
  formData.append("size", size.value);
  formData.append("remarks", remarks.value);

  if (image_file.value) {
    formData.append("image_file", image_file.value);
  }
  const responseApi = ref<any>();

  if (isEdit.value) {
    responseApi.value = await itemStore.dispatchUpdate(idItem.value, formData);
  } else {
    responseApi.value = await itemStore.dispatchCreate(formData);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value ? "Item Successfully Updated" : "Item Successfully Added"
      );
      router.push("/management/item");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadGroupCategory = async () => {
  const { success, message } =
    await groupCategoryStore.dispatchGetCategoryGroups(1, 99);
  if (success) {
    listGroupCategory.value = mapOptionMultiselect(
      await groupCategoryStore.categoryGroups.items,
      "id",
      "name",
      "category_name"
    );
  }
};

const loadUnit = async () => {
  const { success, message } = await unitStore.dispatchGetAll(1, 99);
  if (success) {
    listUnit.value = mapOptionMultiselect(
      await unitStore.units.items,
      "id",
      "name"
    );
  }
};

loadUnit();
loadGroupCategory();

const setImage = (file) => {
  previewUrl.value = "";
  image_file.value = file;
};

const loadDetailItem = async () => {
  const { success, message } = await itemStore.dispatchDetail(idItem.value);
  if (success) {
    detailItem.value = await itemStore?.item?.data;
    name.value = detailItem.value?.name;
    impa_code.value = detailItem.value?.impa_code;
    msg_code.value = detailItem.value?.msg_code;
    group_category_id.value = mapOptionMultiselect(
      detailItem.value?.groupCategory,
      "id",
      "name"
    );
    unit_type_id.value = mapOptionMultiselect(
      detailItem.value?.unitType,
      "id",
      "name"
    );
    size.value = detailItem.value?.size;
    image_file.value = await urlToObject(detailItem.value?.image_link);
    previewUrl.value = detailItem.value?.image_link;
    remarks.value =
      detailItem.value?.remarks == null ? "" : detailItem.value?.remarks;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idItem.value = router.currentRoute.value.params.id.toString();
    loadDetailItem();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(PageLoading, {
              key: 0,
              text: "Processing Data..."
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Item"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/management/item"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Item ")
            ])
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
            class: "row g-3 needs-validation form"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "msg_code",
                    class: "form-label label text-secondary"
                  }, "MSG Code", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      name: "msg_code",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(msg_code) ? (msg_code).value = $event : null)),
                      placeholder: "MSG Code",
                      type: "text",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(msg_code)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).msg_code), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    for: "impa_code",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Impa Code "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      name: "impa_code",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(impa_code) ? (impa_code).value = $event : null)),
                      placeholder: "Impa Code",
                      type: "text",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(impa_code)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).impa_code), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    for: "name",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Name "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      name: "name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                      placeholder: "Name",
                      type: "text",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(name)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", {
                    for: "group_category_id",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Group Category "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_unref(vSelect), {
                      options: listGroupCategory.value,
                      name: "group_category_id",
                      modelValue: _unref(group_category_id),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(group_category_id) ? (group_category_id).value = $event : null)),
                      placeholder: "Group Category"
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).group_category_id), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    for: "unit_type_id",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Unit "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(vSelect), {
                      options: listUnit.value,
                      name: "unit_type_id",
                      modelValue: _unref(unit_type_id),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(unit_type_id) ? (unit_type_id).value = $event : null)),
                      placeholder: "Unit"
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(errors).group_category_id), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "size",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Size "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      name: "size",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
                      placeholder: "Size",
                      type: "text",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(size)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(errors).size), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "remarks",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Remarks "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "remarks",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(remarks) ? (remarks).value = $event : null)),
                      placeholder: "Remarks",
                      type: "text",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(remarks)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(errors).remarks), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  for: "remarks",
                  class: "form-label label text-secondary"
                }, [
                  _createTextVNode("Image "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                (previewUrl.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("img", {
                        src: previewUrl.value,
                        alt: "image-upload"
                      }, null, 8, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(ImageUploader, { onFileResult: setImage })
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                _createElementVNode("button", {
                  class: "btn btn-primary fw-semibold text-white py-2 px-3",
                  type: "submit"
                }, " Save ")
              ], -1))
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})